import { toggleSidebar } from "../../utils/sidebarToggle";

function PageHeader({ onOpen }) {
  return (
    <div className="mainHead d-flex align-items-center justify-content-between pt-3 py-3">
      <div className="headText ms-3 d-flex align-items-center justify-content-center">
        <i className="fa-solid fa-coins" /> Capital
        <button
          onClick={onOpen}
          className="btn btn-sm btn-warning ms-3 d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
          style={{ borderRadius: "10px", fontWeight: "500" }}
        >
          <i className="fa-solid fa-pen-to-square"></i>
          <span className="d-none d-md-block">Update Credentials</span>
        </button>
      </div>
      <div className="headIcons d-flex me-3">
        <div className="iconMain">
          <i className="fa-solid fa-search" />
        </div>
        <a href="capital.html" className="iconMain ms-3 me-3">
          <i className="fa-solid fa-exclamation" style={{ color: "black" }} />
        </a>
        <div className="iconMain" id="sidebarToggle" onClick={toggleSidebar}>
          <i className="fa-solid fa-bars" />
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
